const KEY = "GA_LOCAL_SETTINGS"

function storeSettingsLocally(settings) {
  localStorage.setItem(KEY, JSON.stringify(settings))
}

function loadLocalSettings() {
  return JSON.parse(localStorage.getItem(KEY))
}

export const localSettings = {
  store: storeSettingsLocally,
  load: loadLocalSettings,
}

